export default __webpack_public_path__ + "static/media/TiagoMarinho-1ETHM.73191fb4.mp4";